import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//PNG
import Asset from "../../assets/png/Asset.png";
import Component from "../../assets/png/component.png";
import NameAsset from "../../assets/png/Assetname.png";

//SVG
import Ask from "../../assets/svg/ask.svg";
import Settings from "../../assets/svg/settings.svg";
import ProfilePopup from "./ProfilePopup";
import { getProfileDetailsApi, getOrgLogoApi, getOrgListApi } from "../../components/common/common-api";
import { ReportAnIssueButton } from "../../components/common/report-an-issue-modal";
import DownloadApplication from "../../components/common/download-application";

const Topbar = () => {
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const googlePlayStore = process.env.REACT_APP_GOOGLE_PLAY_STORE;
  const applePlayStore = process.env.REACT_APP_APPLE_STORE;

  const navigate = useNavigate();

  const [firstLetter, setFirstLetter] = useState("");
  const [profileDetail, setProfileDetail] = useState({});
  const [orgLogo, setOrgLogo] = useState("");
  const [orgName, setOrgName] = useState("");
  const [showProfile, setShowProfile] = useState(false);

  useEffect(() => {
    getOrgList();
    getOrgLogo();
    getProfile();
  }, []);
  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response && response.success === true) {
        setOrgLogo(response.image ?? "");
        setOrgName(response.org_name ?? "....");
      }
    } catch (err) {
      console.error("Error fetching organization logo:", err);
    }
  };
  const [orgList, setOrgList] = useState([]);
  const getOrgList = async () => {
    const response = await getOrgListApi();
    if (response.status === 200) {
      if (response.data.success === true) {
        setOrgList(response.data.orgs ?? []);
      }
    }
  };
  const getProfile = async () => {
    try {
      const response = await getProfileDetailsApi();
      if (response.data.success === true) {
        setProfileDetail(response.data.user);
        setFirstLetter(response.data.user.first_name ? response.data.user.first_name.charAt(0) : "");
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };
  return (
    <div
      style={{
        fontFamily: "Lexend Deca",
        width: "100%",
        backgroundColor: "#2d3e50",
        padding: "10px 8px 10px 12px",
      }}
    >
      <Row style={{ width: "100%" }}>
        <Col sm={12} md={6}>
          <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <div>
              <img
                src={Component}
                style={{ width: "30px", height: "30px", cursor: "pointer" }}
                alt="Home Icon"
                onClick={() => {
                  window.open(accountsUrl, "_blank", "noopener,noreferrer");
                }}
              />
            </div>

            <div>
              <img src={orgLogo ? orgLogo : Asset} style={{ height: "32px" }} alt="Organization Logo" />
            </div>

            {!orgLogo && (
              <div>
                <img src={NameAsset} style={{ height: "20px", width: "65px" }} />
              </div>
            )}
          </div>
        </Col>

        <Col sm={12} md={6}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              justifyContent: "end",
            }}
          >
            {/* download app added */}
            <div>
              <DownloadApplication name="Asset" googlePlayStore={googlePlayStore} applePlayStore={applePlayStore} />
            </div>
            <div>
              <ReportAnIssueButton />
            </div>
            <div style={{ cursor: "pointer" }}>
              <img src={Ask} style={{ height: "44px", cursor: "pointer" }} onClick={() => navigate("/help")} />
            </div>

            <div>
              <img src={Settings} onClick={() => navigate("/masters/template")} style={{ height: "44px", cursor: "pointer" }} />
            </div>

            <div
              onClick={() => {
                setShowProfile(!showProfile);
              }}
              style={{ cursor: "pointer" }}
            >
              {profileDetail.profile_image != null && profileDetail.profile_image !== "" && (
                <img
                  src={profileDetail.profile_image}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "100px",
                  }}
                  alt="Profile"
                />
              )}
              {(profileDetail.profile_image == null || profileDetail.profile_image === "") && (
                <div
                  style={{
                    cursor: "pointer",
                    width: "44px",
                    height: "44px",
                    borderRadius: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "transparent",
                    border: "2px solid #FFFFFF",
                  }}
                >
                  <div
                    style={{
                      fontSize: "14px",
                      fontWeight: "700",
                      color: "#FFFFFF",
                    }}
                  >
                    {firstLetter}
                  </div>
                </div>
              )}
            </div>
          </div>
          {showProfile && <ProfilePopup orgList={orgList} profileDetail={profileDetail} onClose={() => setShowProfile(false)} orgLogo={orgLogo} orgName={orgName} callProfileFunc={getProfile} />}
        </Col>
      </Row>
    </div>
  );
};

export default Topbar;
